<!--
 * @Descripttion:
 * @version:
 * @Author: shenlin
 * @Date: 2021-11-02 15:49:14
 * @LastEditors: shenlin
 * @LastEditTime: 2022-07-11 15:05:34
-->
<template>
  <div class="container">
    <section class="heder">
      <div class="title"><span></span>丽企大讲堂</div>
      <div class="tip">
        默认调用API接口，若要自定义数据，请打开自定义开关
      </div>
    </section>
    <section class="body">
      <div>
        <el-switch
          v-model="liveFill"
          active-text="自定义数据"
          @change="changeFillStatus"
        >
        </el-switch>
      </div>
      <div v-if="liveFill">
        <el-button @click="show = true" v-if="!show">编 辑</el-button>
        <el-button @click="cancel" v-if="show">取 消</el-button>
        <el-button type="primary" @click="updateFillData" v-if="show"
          >保 存</el-button
        >
      </div>
      <div v-if="liveFill">
        <table border="1" cellspacing="0" cellpadding="10">
          <thead>
            <tr>
              <td>县（市、区）</td>
              <td align="center">
                直播总场数
              </td>
              <td align="center">观看人数</td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in list1" :key="item.county">
              <td>{{ item.county }}</td>
              <td>
                <el-input v-model="item.totalNum" v-if="show"></el-input>
                <div
                  v-else
                  style="height:32px;width:202px;line-height: 32px;text-align: center"
                >
                  {{ item.totalNum }}
                </div>
              </td>
              <td>
                <el-input v-model="item.viewNum" v-if="show"></el-input>
                <div
                  v-else
                  style="height:32px;width:202px;line-height: 32px;text-align: center"
                >
                  {{ item.viewNum }}
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
  </div>
</template>

<script>
import {
  updateFillData,
  changeFillStatus
} from '@api/dataMaintenance/dataMaintenance'
export default {
  props: {
    liveFillData: {
      type: Array,
      default: () => {
        return []
      }
    },
    liveFill: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    newList() {
      return JSON.parse(JSON.stringify(this.liveFillData))
    }
  },
  watch: {
    newList(newVal, oldVal) {
      this.list1 = JSON.parse(JSON.stringify(newVal))
      if (!this.list) {
        this.list = JSON.parse(JSON.stringify(newVal))
      }
    }
  },
  data() {
    return {
      show: false,
      tableList: [
        { county: '莲都区', totalNum: 4, viewNum: 9 },
        { county: '青田县', totalNum: 4, viewNum: 9 },
        { county: '缙云县', totalNum: 4, viewNum: 9 },
        { county: '松阳县', totalNum: 4, viewNum: 9 },
        { county: '云和县', totalNum: 4, viewNum: 9 },
        { county: '庆元县', totalNum: 4, viewNum: 9 },
        { county: '景宁县', totalNum: 4, viewNum: 9 },
        { county: '龙泉市', totalNum: 4, viewNum: 9 },
        { county: '经济开发区', totalNum: 4, viewNum: 9 },
        { county: '总计', totalNum: 4, viewNum: 9 }
      ],
      list: null,
      list1: []
    }
  },
  created() {},
  mounted() {},
  methods: {
    cancel() {
      this.show = false
      this.list1 = JSON.parse(JSON.stringify(this.list))
    },
    updateFillData() {
      updateFillData({ list: this.list1, type: 1 }).then(res => {
        if (res.data.code == '0000') {
          this.$message.success(res.data.msg)
          this.show = false
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    changeFillStatus(val) {
      changeFillStatus({ type: 1, status: val ? 1 : 0 }).then(res => {
        if (res.data.code == '0000') {
          this.$message.success(res.data.msg)
        } else {
          this.$message.error(res.data.msg)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  padding: 12px 0;
  background: #fff;
  .heder {
    > .title {
      display: flex;
      align-items: center;
      line-height: 20px;
      > span {
        display: inline-block;
        width: 4px;
        height: 20px;
        background: #46a6ff;
        border-radius: 3px;
        margin-right: 6px;
      }
    }
    > .tip {
      margin: 20px 0;
      font-size: 16px;
      color: rgba(0, 0, 0, 0.7);
      padding: 5px 10px;
      line-height: 24px;
      background-color: #fafafa;
    }
  }
  .body {
    table {
      border-color: #e8e8e8;
    }
    > div {
      margin-bottom: 20px;
    }
    /deep/ .el-input__inner {
      height: 32px;
      line-height: 32px;
    }
  }
}
</style>
